export default __webpack_public_path__ + "static/media/where_accept_elad.c72bbed8.jpg";